// extracted by mini-css-extract-plugin
module.exports = {"progress":"LoadingButton_progress__UJ63b"};